const FooterText = [
  'Copyright © 2018 AcademME, LLC. All rights reserved. A Virginia Limited Liability Company. AcademeME is a trade name for AcademME, LLC'
]

export default FooterText



// WEBPACK FOOTER //
// src/text/footer-text.js